import { IQuickSortState } from "../../IQuickSortState";
import { IQuickSortContext } from '../../IQuickSortContext';
import { QuickSortStep } from '../../enums/QuickSortStep';
import { assertIsDefined } from "../../../tsutils/assertIsDefined";
import { QuickSortCompareLowHighState } from "./QuickSortCompareLowHighState";

export class QuickSortEntryState implements IQuickSortState {

  ThisQuickSortStep = QuickSortStep.QuickSortEntry;
  
  Description = "Quick Sort Entry (pop values from stack)";

  private _savedState : { 
    PoppedObjects: Array<any> | undefined,
    SavedNumbers: Array<number> | undefined,
    SavedLo: number | undefined,
    SavedHi: number | undefined
  } | undefined;

  private _context : IQuickSortContext | undefined;
  
  SetContext(context: IQuickSortContext): void {
    this._context = context;
  } 
  
  Do(): void {
    assertIsDefined(this._context);
    assertIsDefined(this._context.Numbers);
    assertIsDefined(this._context.AlgoStack);
    

    let numbers: Array<number> = this._context.AlgoStack.pop() as Array<number>;
    let lo: number = this._context.AlgoStack.pop() as number;
    let hi: number = this._context.AlgoStack.pop() as number;
    let savedNumbers: Array<number> = this._context.Numbers;
    let savedLo: number | undefined = this._context.Lo;
    let savedHi: number | undefined = this._context.Hi;

    if (this._savedState === undefined) {
      this._savedState = {
        PoppedObjects: [numbers, lo, hi],
        SavedNumbers: savedNumbers,
        SavedLo: savedLo,
        SavedHi: savedHi
      }
    }
    else {
      this._savedState.PoppedObjects = [numbers, lo, hi];
      this._savedState.SavedNumbers = savedNumbers;
      this._savedState.SavedLo = savedLo;
      this._savedState.SavedHi = savedHi;
    }

    this._context.Numbers = numbers;
    this._context.Lo = lo;
    this._context.Hi = hi;

  }

  Undo(): void {
    assertIsDefined(this._context);
    assertIsDefined(this._context.Numbers);
    assertIsDefined(this._context.AlgoStack);
    assertIsDefined(this._savedState);
    assertIsDefined(this._savedState.PoppedObjects);

    this._context.AlgoStack.push(this._savedState.PoppedObjects[2]);
    this._context.AlgoStack.push(this._savedState.PoppedObjects[1]);
    this._context.AlgoStack.push(this._savedState.PoppedObjects[0]);

    this._context.Numbers = this._savedState.SavedNumbers;
    this._context.Lo = this._savedState.SavedLo;
    this._context.Hi = this._savedState.SavedHi;
  }

  Exit(): void {
    if (this._context) {
      this._context.TransitionTo(new QuickSortCompareLowHighState());
    }
  }
}